import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FuseSharedModule } from "@fuse/shared.module";
import { LoginComponent } from "app/main/module/auth/login/login.component";
import { SharedModule } from "../../common/shared.module";
import { ConfigService } from "../../common/config/config.service";
import { CommonModule } from "@angular/common";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpClientModule, HttpClient } from '@angular/common/http'; // Make sure HttpClientModule is here too!
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { Observable } from "rxjs";
import { TranslateHttpLoader } from '@ngx-translate/http-loader';


const routes = [
    {
        path: "login",
        component: LoginComponent,
    },
];

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
    declarations: [LoginComponent],
    providers: [ConfigService],
    imports: [
        RouterModule.forChild(routes),
        SharedModule,
        FuseSharedModule,
        CommonModule,
        BrowserAnimationsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        // NgxSpinnerModule
    ],
    bootstrap: [LoginComponent],
})
export class LoginModule {}
